module.exports = __webpack_public_path__ + "img/Mullen_Lauren.93e423c3.png";